import { Card } from '../ui/card';
import { Bookmark } from 'lucide-react';

export const BookmarksCard = ({ bookmarks }) => {
  if (!bookmarks || bookmarks.length === 0) return null;

  return (
    <Card className="p-6 sm:p-8 mb-8" data-testid="bookmarks-card">
      <div className="flex items-center gap-3 mb-4">
        <Bookmark className="w-6 h-6 sm:w-8 sm:h-8 text-indigo-600" />
        <h2 className="text-xl sm:text-2xl font-serif font-bold">Bookmarked Stories</h2>
      </div>

      <div className="space-y-3">
        {bookmarks.map((story) => (
          <a
            key={story.id}
            href={`/story/${story.id}`}
            className="block p-4 border border-gray-200 rounded-lg hover:border-indigo-400 hover:bg-indigo-50 transition-colors"
            data-testid={`bookmark-item-${story.id}`}
          >
            <h3 className="font-medium text-sm sm:text-base text-gray-900 line-clamp-2">
              {story.primary_headline}
            </h3>
            <p className="text-xs text-gray-500 mt-1">{story.article_count} sources</p>
          </a>
        ))}
      </div>
    </Card>
  );
};
